import React, { useContext } from 'react';
import { Card, CardBody, CardText, CardTitle } from 'reactstrap';
import { role } from 'config/role';
import { authContext } from 'contexts/AuthContext';

const RoleBasedPage = () => {
  const { auth } = useContext(authContext);
  const { data } = auth;

  return (
    <div>
      Card will show according to the role :{data.role}
      {data.role === role.ADMIN && (
        <Card className="w-100 h-100 mt-5 bg-primary text-white ">
          <CardBody>
            <CardTitle>Role : {data.role}</CardTitle>
            <CardText>
              This Card is only accessible for user: Admin {data.role}
            </CardText>
          </CardBody>
        </Card>
      )}
      {data.role === role.USER && (
        <Card className="w-100 h-100 mt-5 bg-info text-white ">
          <CardBody>
            <CardTitle>Role : {data.role}</CardTitle>
            <CardText>
              This Card is only accessible for user : {data.role}
            </CardText>
          </CardBody>
        </Card>
      )}
    </div>
  );
};

export default RoleBasedPage;
